import SignContractorInterviewEvent from "../../../../src/events/2022/07/sign-contractor-interview/main";
import * as React from 'react';
export default {
  SignContractorInterviewEvent,
  React
};